define('home/models/Topic',[
    'underscore',
    'backbone',

    'core/strings',

    'core/UniqueModel',
], function (
    _,
    Backbone,

    strings,

    UniqueModel
) {
    'use strict';

    var gettext = strings.get;

    var Topic = Backbone.Model.extend({
        idAttribute: 'identifier',
        defaults: {
            identifier: null,
            displayName: null,
        },

        validate: function (attrs) {
            var topicName = attrs.displayName;
            if (!topicName) {
                return {
                    attrName: 'displayName',
                    message: gettext('Topic name cannot be empty.'),
                };
            }

            var nameRanges = Topic.TOPIC_NAME_RANGES;

            if (topicName.length > nameRanges.maxLength ||
                topicName.length < nameRanges.minLength) {

                return {
                    attrName: 'displayName',
                    message: strings.interpolate(
                        gettext('A topic must be between %(minLength)s and %(maxLength)s characters.'), {
                            minLength: nameRanges.minLength,
                            maxLength: nameRanges.maxLength,
                        }
                    ),
                };
            }
        },
    }, {

        TOPIC_NAME_RANGES: {
            minLength: 2,
            maxLength: 30,
        },

        cleanTopicName: function (topicName) {
            return topicName
                // Remove extra whitespace
                .replace(/\s+/g, ' ')
                .trim();
        },

        getOrCreateTopic: function (displayName) {
            var cleanDisplayName = Topic.cleanTopicName(displayName);

            if (!cleanDisplayName)
                return null;

            // Search for an existing topic with the same display name. Ignore casing,
            // different casings map to the same topic.
            var lowerTopicName = cleanDisplayName.toLowerCase();
            var existing = _.find(UniqueModel.pool(Topic), function (topic) {
                return topic.get('displayName').toLowerCase() === lowerTopicName;
            });

            // Existing topic found, return.
            if (existing)
                return existing;

            return new UniqueModel(Topic, {
                displayName: cleanDisplayName,
            });
        },

    });

    UniqueModel.addType('Topic', Topic);

    return Topic;
});

